import type { SVGProps } from "react";

const SvgCsobLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 46.08 46.08"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    {...props}
  >
    <path
      style={{
        fill: "#036",
      }}
      transform="scale(1.92)"
      d="M0 0h24v24H0z"
    />
    <path
      d="M20.179 14.399h-3.113v5.127h2.877c1.068 0 2.057-.175 2.057-1.455 0-.46-.347-.979-.936-1.153.575-.212.845-.605.845-1.222 0-.837-.614-1.297-1.73-1.297m-.798 3.072c.44 0 .628.133.628.443 0 .418-.492.45-.643.45h-.419v-.893zm.007-1.995q.57 0 .572.42c0 .342-.334.414-.616.414h-.397v-.834zm-8.173 1.486c0 1.71.976 2.648 2.752 2.648 1.787 0 2.773-.938 2.773-2.648 0-1.683-1.011-2.648-2.773-2.648-1.75 0-2.752.965-2.752 2.648m2.074 0c0-.872.228-1.314.678-1.314.607 0 .689.751.696 1.315-.008.634-.068 1.314-.696 1.314-.457 0-.678-.43-.678-1.315m-6.765-.966c0-1.116.86-1.682 2.557-1.682.516 0 1.09.061 1.617.174l.052.009v1.431l-.088-.034a4.3 4.3 0 0 0-1.415-.246c-.361 0-.732.031-.732.263 0 .185.321.249.728.329.767.153 1.819.362 1.819 1.632 0 1.57-1.696 1.739-2.426 1.739-.708 0-1.31-.07-2.012-.237l-.053-.013v-1.447l.093.039c.48.205 1.076.324 1.64.324.371 0 .766-.074.766-.277 0-.195-.325-.265-.737-.35-.764-.16-1.809-.381-1.809-1.654m-2.967-2.547.034.041c.005.005.482.564 1.301.572.769.007 1.185-.437 1.19-.442l.031-.034.223.168-.038.04a2.5 2.5 0 0 1-.801.565c.223.025.433.064.683.11l.141.027v1.427l-.066-.022c-.291-.096-.604-.183-.916-.183-.824 0-1.338.46-1.338 1.202 0 .78.478 1.245 1.277 1.245.312 0 .626-.061.989-.191l.067-.024v1.433l-.036.011a5.2 5.2 0 0 1-1.346.203C3.132 19.597 2 18.56 2 16.891c0-1.178.687-2.064 1.85-2.407a2.4 2.4 0 0 1-.869-.43l-.043-.036.581-.531m8.563-2.751a3.369 3.369 0 1 1 .002-6.738 3.369 3.369 0 0 1-.002 6.738m2.485-.641a4.43 4.43 0 0 1-3.224 1.39 4.47 4.47 0 0 1-2.714-.924c-3.678.386-6.412.933-6.412.933v1.488l19.488-.002.001-3.071s-3.324-.019-7.139.186"
      style={{
        fill: "#fff",
        fillRule: "nonzero",
      }}
      transform="scale(1.92)"
    />
  </svg>
);

export default SvgCsobLogo;
